module.exports = __webpack_public_path__ + "img/symbol_6.c6d23226.png";